import Vue from "vue";
import SkeletonLoader from "@/components/Elements/SkeletonLoader.vue";

export default Vue.extend({
  name: "PartSearchTilesSkeleton",
  components: { SkeletonLoader },
});
